<template>
  <div class="bg-slate-100 min-h-screen">
    <div>
      <NavigationBarComp />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import NavigationBarComp from "@/components/NavigationBarComp.vue";

  import { fetchUsers, fetchPointLocations } from "@/states/user";
  import { fetchAppProps } from "@/states/app";

  export default {
    name: "DashboardLayout",
    components: {
      NavigationBarComp
    },
    async mounted() {
      await fetchUsers();
      await fetchPointLocations();
      await fetchAppProps();
    }
  };
</script>
